/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React from 'react';
import TextInput from './input/TextInput';
import InputWithCheckbox from './input/InputWithCheckbox';
import NumberInput from './input/NumberInput';
import CalculatedInput from './input/CalculatedInput';
import SelectInput from './input/SelectInput';
import { ColumnInputProps, TableColumn } from './InputInterface';
import DateInput from '../DateInput';

export const TableTypes = {
  text: 'text',
  textCheckbox: 'textCheckbox',
  number: 'number',
  calculated: 'calculated',
  date: 'date',
  valueList: 'valueList',
  valueListMulti: 'valueListMulti',
  percentage: 'percentage',
}

const TableInputMap = {
  [TableTypes.textCheckbox]: InputWithCheckbox,
  [TableTypes.text]: TextInput,
  [TableTypes.number]: NumberInput,
  [TableTypes.percentage]: NumberInput,
  [TableTypes.date]: DateInput,
  [TableTypes.calculated]: CalculatedInput,
  [TableTypes.valueList]: SelectInput,
  [TableTypes.valueListMulti]: SelectInput,
}

export const getTableInputType = (column: TableColumn) => {
  if (!column) {
    return TableTypes.text;
  }

  if (column.calculation?.formula) {
    return TableTypes.calculated;
  }

  if ((column.options && column.options.length > 0) || column.listId) {
    if (column.type === TableTypes.valueListMulti) {
      return TableTypes.valueListMulti;
    }
    return TableTypes.valueList;
  }

  return column.type;
}

export default function TableFactory(props: ColumnInputProps) {
  const type = getTableInputType(props.column)
  const InputComponent = TableInputMap[type];
  if (!InputComponent) {
    return `Unsupported value type "${type}"`;
  }

  const { column, index, universalTracker } = props;
  const id = `input-${column.code}-${index}-${universalTracker.getId()}`;

  const multi = type === TableTypes.valueListMulti;
  return <InputComponent key={id} {...props} multi={multi} />;
}
